import Api from '@/services/Api'
import axios from 'axios'

export default {
  async getDepartures (stopId) {
    const response = await axios.get(`https://svc.metrotransit.org/nextripv2/${stopId}`)
    return response.data?.departures
  },

  async getVehicles (routeId) {
    const response = await axios.get(`https://svc.metrotransit.org/nextripv2/vehicles/${routeId}`)
    return response.data
  },

  getTransitStops () {
    return Api().get('/api/v1/transitstops')
  },

  addTransitStop (params) {
    return Api().post('/api/v1/transitstops', params, {
      withCredentials: true
    })
  },

  updateTransitStop (params) {
    return Api().put(`/api/v1/transitstops/${params._id}`, params, {
      withCredentials: true
    })
  },

  getTransitStop (id) {
    return Api().get(`/api/v1/transitstops/${id}`)
  },

  deleteTransitStop (id) {
    return Api().delete(`/api/v1/transitstops/${id}`, {
      withCredentials: true
    })
  }
}
